import { lazy } from 'react'

export const TermsOfUse = lazy(() => import('./v1/TermsOfUse'))
